import * as React from 'react';

function SvgVerified(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32.254} height={31.643} {...props}>
      <defs>
        <style>{'.verified_svg__prefix__cls-1{fill:#00cd00}'}</style>
      </defs>
      <g id="verified_svg__prefix__verified" transform="translate(-290.083 -379.44)">
        <path
          id="verified_svg__prefix__Path_5541"
          d="M318.873 389.8a14.549 14.549 0 11-6.143-6.82l.672-.766a15.517 15.517 0 106.306 7.007z"
          className="verified_svg__prefix__cls-1"
          data-name="Path 5541"
        />
        <path
          id="verified_svg__prefix__Path_5544"
          d="M1221.4 193.727l-17.594 19.726-3.337-4.705a.672.672 0 10-1.095.778l3.825 5.391a.674.674 0 00.511.282h.037a.675.675 0 00.5-.224l18.154-20.352a.673.673 0 10-1-.9z"
          className="verified_svg__prefix__cls-1"
          data-name="Path 5544"
          transform="translate(-900.237 185.938)"
        />
      </g>
    </svg>
  );
}

export default SvgVerified;
